module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2r"
  }, [_c('a', {
    attrs: {
      "id": "intro"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "noindentia"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("F")]), _vm._v("or most of my life, I’ve hated the word "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("diet")]), _vm._v(". I’m not a fan of the word for many reasons, but mostly because no “diet” has ever worked for me. I’ve just never figured out how to reconcile eating “diet foods” with living a happy and balanced life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Does this sound familiar?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most women I work with feel the same way: when we hear the word "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("diet")]), _vm._v(", we quickly duck into a hidden place of shame, where we secretly know we’ll fail—despite our best efforts. That’s because most diets try to force us into a kind of submission—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Eat this! Avoid that!")]), _vm._v("—that undermines everything we know to be true about being confident, healthy, independent women.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For me, like many of you, there’s nothing worse than putting all of our past failures aside and making a commitment to this or that diet, only to find that, after initially losing weight (and usually suffering in the process), the pounds that we diligently shed (usually due to a degree of willpower that is unsustainable) find their way back to us. Oh, and I’m sure you noticed that those lost-and-gained pounds usually bring a few new pounds home with them.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("It’s high time we throw up our hands and admit that trying to lose weight the “traditional” way just doesn’t work. But what then? Should we just resign ourselves to the fact that we may be carrying around five, ten, twenty, or more pounds that keep us from feeling ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("as sexy and healthy as we deserve to feel? Do we settle for mercurial mood swings, constant food cravings, terrible PMS or scorching hot flashes, foggy brains, and low energy? Or do we toss the notion of dieting out the window and decide that we’re just going to simplify our lives and finally get back to eating the way we were always designed to do?")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It really is that easy. All we need to do is look to our ancestors for the answers. And no, I’m not talking from the time of your great-great-grandma. I’m talking about going way back. Back to the time before smart phones, cars, electricity—even farming. It all begins and ends for us women, nutritionwise and healthwise, back in Paleolithic times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I discovered that if I follow a diet similar to the one that my long-ago Paleolithic sisters ate, I can be lean, strong, sexy, and healthy. Forever. And you can be too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And here’s why: most diets fail for a reason that may surprise you. It’s not because they’re so restrictive, which they are, and that’s just never any good—especially for someone like me who believes in balance and freedom of choice rather than deprivation. Most diets fail because they sabotage our metabolism by promoting a way of eating (usually low in calories and protein) that ignores how our bodies work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On a low-calorie diet, your body notices that it’s receiving fewer calories, so it sheds some weight initially. While this is happening, your body’s ability to produce, distribute, and balance key hormones (the interplay of hormones is what makes up metabolism) efficiently becomes compromised, and though you may lose a few pounds, (or even more than a few), your system is otherwise sent into distress. When this happens, your health—including your body’s ability to regulate weight—is thrown out of whack. Your body says, “Okay, gorgeous, it’s just a matter of time before you and I either (1) plateau on that particular diet and stop losing weight or (2) throw in the towel and give in to our debilitating hunger, fatigue, moodiness, sleep deprivation, cravings, and other symptoms of metabolic distress.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("It seems that our ancestors didn’t suffer from this kind of metabolic trauma. Instead, they ate for fuel and were rewarded with the physical strength, stamina, and body health they needed to make it to the next day.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ve been a holistic nutritionist in New York City for nearly two decades, and, believe me, I’ve seen every fad diet out there. But the Paleo diet, which has been around for millions of years, works, especially when it’s adapted by someone like me, who understands how to tweak these ancient principles and apply them to our modern lives, which are fast, complicated, fun, and, at times, pretty overwhelming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paleo meets feminine in my Paleo Chic plan, which is custom tailored to meet the ancient needs of the modern woman. Eating like our human ancestors did is particularly effective for today’s modern woman who wants to be slim, toned, and fit. The Paleo diet you’ve heard so much about isn’t just for hard-core CrossFitters and meat-loving men. By eating like a cavewoman, you’ll enjoy foods that are protein rich, hormone balancing, detoxifying, and satisfying.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My Paleo Chic diet is the ultramodern version of the Paleo diet that is specifically tailored to the nutritional, hormonal, and real world needs of women like you and me. It is a three-step evolution in achieving transformation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Paleo Detox plan, which is the first phase, hits the metabolic reset button by clearing out extra sugar and extra carbs. Doing so will quench your inner inflammatory fires and let your body release extra water and bloat. You’ll also give your gut, or intestinal tract, a rest and help it start to repair itself by clearing out allergenic foods that are causing you to pack on extra weight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Paleo Reset plan gently reintroduces carbs to sustain your energy and throws you a bone with an optional “cheat meal.” You will still continue on your weight loss path in this phase, with the addition of a complex starch in your day.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("And the Paleo Chic plan lets you live gorgeously as a modern cavewoman and maintain your physique with a whole-foods, balanced, clean way of eating. Within the Paleo Chic realm, you can ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("enjoy up to two complex starches per day and up to two cheat meals per week for the uber-active exercisers.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Most diets take a one-size-fits-all approach; my plan lets you custom tailor the program to your individual needs. And it will give you the tools to streamline your relationship to food and streamline your body. Think of carbs as your metabolic modulators on this plan: eating less generates faster results; eating more generates slower results. Your energy levels, workouts, and changes in overall body fat will all dictate the role that carbs play in your everyday food choices and in changing your physique. And when you understand the relationship that they have with your body, you can finally get the results you’re looking for—for good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ve watched, gratified and humbled, how the Paleo Chic plan has transformed the lives of hundreds of my clients, start to finish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now it’s time for you to reap the benefits of the Paleo Chic plan too.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("The Paleo Chic diet will help you:")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("boost your energy;")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("balance your hormones naturally;")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("burn fat;")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("stabilize your brain biochemistry and gain control over cravings;")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("promote digestive health and improve nutrient absorption;")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("build lean muscle mass;")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("sleep deeply and restoratively;")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("manage and reduce stress;")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("detoxify your body; and")]), _vm._v(" "), _c('p', {
    staticClass: "hangingb"
  }, [_vm._v("improve your hormonal balance and metabolic functioning.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("The Paleo Chic diet is not about:")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("calorie counting;")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("low-fat dieting;")])]), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("living with hunger and cravings;")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "hanging"
  }, [_vm._v("having to engage in high-impact fitness regimens that are hard to sustain;")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("forfeiting muscle for weight loss;")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("promoting processed foods; and")]), _vm._v(" "), _c('p', {
    staticClass: "hangingb"
  }, [_vm._v("abusing your body (or soul) in any way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Your body knows what it needs to function optimally—in fact, it’s known for a very, very long time. And I know that you can heal your body with food. All you need to bring to the table is your willingness to be the best, sexiest, sveltest, and healthiest you possible. If you follow my plan, you’ll lose those annoying extra pounds, build lean muscle mass, and feel like the gorgeous goddess you are meant to be.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Here are the benefits that the Paleo Chic diet can help you achieve:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• You can eat plenty of food and lose weight.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• You will not feel hungry or experience overwhelming cravings, because you will eat three healthful meals and two nutritious snacks every day.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Your body can become the lean, mean fighting machine that it is designed to be.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• You will lose fat and gain lean muscle mass.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Your skin will glow.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Your blood sugar levels will remain steady, so you won’t crash and burn or have nasty mood swings.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• You will enjoy deep, restorative sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Your body and mind will be better able to cope with and ward off stress.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Most importantly, eating like a Paleo cavewoman will ground you in a very deep, authentic way of living that will free up your most valuable and vital resources.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("• • • ")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("If you’re like me, though, jumping into the deep end with anything radically new can be a recipe for disaster. I’ve found that when I approach a major lifestyle change patiently, I have a better chance of sustaining that change over the long term and thus setting myself up for success. That’s why I encourage any of you who want to lose weight, feel more energetic, balance your hormones, and just be healthier to try my Paleo Chic diet for a month. That’s all. Just give it four weeks. I feel confident that by making this minimal commitment to detox your body and eat delicious, clean food, you will want to make this a way of life.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("During the first month, I’m going to encourage you to give your body a fighting chance at health by ditching all those toxic processed foods—soda, candy, crackers, snack foods, and so on—that you may have been feeding yourself. I’ll also ask you to look at your sleep habits and commit to getting adequate, rejuvenating rest each night. I’ll also coach you to de-stress your life as best you can, too. I’ll show you how to increase your intake of lean, healthy proteins while reducing your intake of carbohydrates (especially the processed kind). I’ll ask you to be extra nice to yourself, because it takes time—and a lot of compassion—to unlearn all of our modern eating habits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How do I know all of this? Been there, done that. Now that I eat like a cavewoman, I’ve never felt and looked better.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before you make any changes at all, take a photograph of yourself just as you are now. Have your body fat measured by a strength coach or nutritionally oriented physician who knows how to use body fat calipers to determine your current muscle-to-fat ratio. When the first thirty days are up, I want you to take another picture and recheck your caliper measurements. I think you’ll be stunned by how much you will have already begun to transform yourself.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("The Paleo Chic diet will improve your overall health and quality of life. So I hope that you embrace these changes and think of them as giving your body a gift for the rest of your life. As you embark upon ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("creating your own Paleo kitchen, you may need to initially prepare meals that are different from the ones your family typically eats until everyone gets on board. That’s all okay, and it’s part of this process. I want to encourage you to be as passionate as possible about this way of eating, because I know how well the Paleo Chic plan works. Each and every one of us has unlimited potential to build lean muscle, burn body fat, and stoke our metabolic fire. The changes in your body will come with time, but the first step lies in changing how you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("feel")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Cavewomen Don’t Get Fat")]), _vm._v(" is about where we’re at right now societally. Now more than ever we need to go back to the land and clear our bodies of the fake-food clutter. We need to understand that millions of years of evolution can’t be wrong, and that returning to our roots will restore our health, balance hormones, revitalize energy, and burn fat. It’s exactly the wake-up call we women need to reclaim our forgotten bodies. Let’s get started!")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-798567f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 78
// module chunks = 0